import { render, staticRenderFns } from "./CartUpsell.vue?vue&type=template&id=ed014148"
import script from "./CartUpsell.vue?vue&type=script&lang=js"
export * from "./CartUpsell.vue?vue&type=script&lang=js"
import style0 from "./CartUpsell.vue?vue&type=style&index=0&id=ed014148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports